// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root,
[data-bs-theme=light] {
    --bs-card-bg: #F7F7F8;
    --bs-card-bg-rgb: 247, 247, 248;

    --bs-border-color: #eeeeee;
    --bs-border-color-translucent: rgba(0, 0, 0, 0.1);

    --text-black-50: rgba(0, 0, 0, 0.5);
    --transition-3s: all ease-in-out 0.3s;

    --light-pink: #F4EDFA;
    --light-green: #EDFAF2;
    --light-blue: #EDF3FA;
    --light-orange: #FAEDED;
    --light-gray: #F9F9FA;

    --bs-success: #39c645;
    --bs-success-rgb: 57, 198, 69;
    --bs-danger: #ff1f35;
    --bs-danger-rgb: 255, 31, 53;
    --bs-warning: #f9bc06;
    --bs-warning-rgb: 249, 188, 6;
}

[data-bs-theme=dark] {
    color-scheme: dark;
    --bs-body-bg: #000000;
    --bs-card-bg: #121212;
    --bs-border-color: #262626;
    --bs-border-color-translucent: rgba(256, 256, 256, 0.15);
    /* --bs-card-bg: #1F1F1F; */
    --bs-card-bg-rgb: 31, 31, 31;

    --text-black-50: rgba(255, 255, 255, 0.5);

    --light-pink: #F4EDFA;
    --light-green: #EDFAF2;
    --light-blue: #EDF3FA;
    --light-orange: #FAEDED;
    --light-gray: #F9F9FA;
}

[data-thunderal="theme-default"],
[data-thunderal="theme-indigo"] {
    --bs-primary: #6C50BF;
    --bs-primary-rgb: 108, 80, 191;
    --bs-primary-bg-subtle: #BABDFD;
    --bs-btn-bg: #6C50BF;
    --bs-pagination-color: var(--bs-primary);
    --bs-pagination-active-bg: var(--bs-primary);
    --bs-nav-pills-link-active-bg: #5539a9;

    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));
}

[data-thunderal="theme-blue"] {
    --bs-primary: #4178E5;
    --bs-primary-rgb: 65, 120, 229;
    --bs-primary-bg-subtle: #b8c8e8;
    --bs-btn-bg: #4178E5;
    --bs-pagination-color: var(--bs-primary);
    --bs-pagination-active-bg: var(--bs-primary);
    --bs-nav-pills-link-active-bg: #3267d3;

    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));
}

[data-thunderal="theme-cyan"] {
    --bs-primary: #53bdb1;
    --bs-primary-rgb: 83, 189, 177;
    --bs-primary-bg-subtle: #c5e4e0;
    --bs-btn-bg: #53bdb1;
    --bs-pagination-color: var(--bs-primary);
    --bs-pagination-active-bg: var(--bs-primary);
    --bs-nav-pills-link-active-bg: #3da99d;

    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));
}

[data-thunderal="theme-blush"] {
    --bs-primary: #ED7AA0;
    --bs-primary-rgb: 225, 86, 160;
    --bs-primary-bg-subtle: #e9b3c5;
    --bs-btn-bg: #ED7AA0;
    --bs-pagination-color: var(--bs-primary);
    --bs-pagination-active-bg: var(--bs-primary);
    --bs-nav-pills-link-active-bg: #d06287;

    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));
}

[data-thunderal="theme-orange"] {
    --bs-primary: #ff784a;
    --bs-primary-rgb: 255, 120, 74;
    --bs-primary-bg-subtle: #ffc9b7;
    --bs-btn-bg: #ff784a;
    --bs-pagination-color: var(--bs-primary);
    --bs-pagination-active-bg: var(--bs-primary);
    --bs-nav-pills-link-active-bg: #ff6c3b;

    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));
}`, "",{"version":3,"sources":["webpack://./src/assets/css/theme.css"],"names":[],"mappings":"AAAA;;IAEI,qBAAqB;IACrB,+BAA+B;;IAE/B,0BAA0B;IAC1B,iDAAiD;;IAEjD,mCAAmC;IACnC,qCAAqC;;IAErC,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;;IAErB,qBAAqB;IACrB,6BAA6B;IAC7B,oBAAoB;IACpB,4BAA4B;IAC5B,qBAAqB;IACrB,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,qBAAqB;IACrB,0BAA0B;IAC1B,wDAAwD;IACxD,2BAA2B;IAC3B,4BAA4B;;IAE5B,yCAAyC;;IAEzC,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;;IAEI,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;IAC/B,oBAAoB;IACpB,wCAAwC;IACxC,4CAA4C;IAC5C,sCAAsC;;IAEtC,yFAAyF;AAC7F;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;IAC/B,oBAAoB;IACpB,wCAAwC;IACxC,4CAA4C;IAC5C,sCAAsC;;IAEtC,yFAAyF;AAC7F;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;IAC/B,oBAAoB;IACpB,wCAAwC;IACxC,4CAA4C;IAC5C,sCAAsC;;IAEtC,yFAAyF;AAC7F;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;IAC/B,oBAAoB;IACpB,wCAAwC;IACxC,4CAA4C;IAC5C,sCAAsC;;IAEtC,yFAAyF;AAC7F;;AAEA;IACI,qBAAqB;IACrB,8BAA8B;IAC9B,+BAA+B;IAC/B,oBAAoB;IACpB,wCAAwC;IACxC,4CAA4C;IAC5C,sCAAsC;;IAEtC,yFAAyF;AAC7F","sourcesContent":[":root,\n[data-bs-theme=light] {\n    --bs-card-bg: #F7F7F8;\n    --bs-card-bg-rgb: 247, 247, 248;\n\n    --bs-border-color: #eeeeee;\n    --bs-border-color-translucent: rgba(0, 0, 0, 0.1);\n\n    --text-black-50: rgba(0, 0, 0, 0.5);\n    --transition-3s: all ease-in-out 0.3s;\n\n    --light-pink: #F4EDFA;\n    --light-green: #EDFAF2;\n    --light-blue: #EDF3FA;\n    --light-orange: #FAEDED;\n    --light-gray: #F9F9FA;\n\n    --bs-success: #39c645;\n    --bs-success-rgb: 57, 198, 69;\n    --bs-danger: #ff1f35;\n    --bs-danger-rgb: 255, 31, 53;\n    --bs-warning: #f9bc06;\n    --bs-warning-rgb: 249, 188, 6;\n}\n\n[data-bs-theme=dark] {\n    color-scheme: dark;\n    --bs-body-bg: #000000;\n    --bs-card-bg: #121212;\n    --bs-border-color: #262626;\n    --bs-border-color-translucent: rgba(256, 256, 256, 0.15);\n    /* --bs-card-bg: #1F1F1F; */\n    --bs-card-bg-rgb: 31, 31, 31;\n\n    --text-black-50: rgba(255, 255, 255, 0.5);\n\n    --light-pink: #F4EDFA;\n    --light-green: #EDFAF2;\n    --light-blue: #EDF3FA;\n    --light-orange: #FAEDED;\n    --light-gray: #F9F9FA;\n}\n\n[data-thunderal=\"theme-default\"],\n[data-thunderal=\"theme-indigo\"] {\n    --bs-primary: #6C50BF;\n    --bs-primary-rgb: 108, 80, 191;\n    --bs-primary-bg-subtle: #BABDFD;\n    --bs-btn-bg: #6C50BF;\n    --bs-pagination-color: var(--bs-primary);\n    --bs-pagination-active-bg: var(--bs-primary);\n    --bs-nav-pills-link-active-bg: #5539a9;\n\n    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));\n}\n\n[data-thunderal=\"theme-blue\"] {\n    --bs-primary: #4178E5;\n    --bs-primary-rgb: 65, 120, 229;\n    --bs-primary-bg-subtle: #b8c8e8;\n    --bs-btn-bg: #4178E5;\n    --bs-pagination-color: var(--bs-primary);\n    --bs-pagination-active-bg: var(--bs-primary);\n    --bs-nav-pills-link-active-bg: #3267d3;\n\n    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));\n}\n\n[data-thunderal=\"theme-cyan\"] {\n    --bs-primary: #53bdb1;\n    --bs-primary-rgb: 83, 189, 177;\n    --bs-primary-bg-subtle: #c5e4e0;\n    --bs-btn-bg: #53bdb1;\n    --bs-pagination-color: var(--bs-primary);\n    --bs-pagination-active-bg: var(--bs-primary);\n    --bs-nav-pills-link-active-bg: #3da99d;\n\n    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));\n}\n\n[data-thunderal=\"theme-blush\"] {\n    --bs-primary: #ED7AA0;\n    --bs-primary-rgb: 225, 86, 160;\n    --bs-primary-bg-subtle: #e9b3c5;\n    --bs-btn-bg: #ED7AA0;\n    --bs-pagination-color: var(--bs-primary);\n    --bs-pagination-active-bg: var(--bs-primary);\n    --bs-nav-pills-link-active-bg: #d06287;\n\n    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));\n}\n\n[data-thunderal=\"theme-orange\"] {\n    --bs-primary: #ff784a;\n    --bs-primary-rgb: 255, 120, 74;\n    --bs-primary-bg-subtle: #ffc9b7;\n    --bs-btn-bg: #ff784a;\n    --bs-pagination-color: var(--bs-primary);\n    --bs-pagination-active-bg: var(--bs-primary);\n    --bs-nav-pills-link-active-bg: #ff6c3b;\n\n    --primary-gradient: linear-gradient(-45deg, var(--primary-color), var(--secondary-color));\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
